<div class="toast-stack" role="status" aria-live="polite">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [class]="'toast--' + toast.type">
      <span class="toast__icon" aria-hidden="true">
        @switch (toast.type) {
          @case ('success') { ✓ }
          @case ('error') { ✕ }
          @default { ℹ }
        }
      </span>
      <span class="toast__message">{{ toast.message }}</span>
      <button type="button" class="toast__close" (click)="dismiss(toast.id)" aria-label="Dismiss">
        ×
      </button>
    </div>
  }
</div>
